import { Sparkles } from "lucide-react";
import Reveal from "@/components/site/Reveal";
import FoxMotif from "@/components/site/FoxMotif";
import { getIcon } from "@/lib/icons";

export const About = ({ content }) => {
  const c = content || {};
  const values = c.values || [];

  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative pf-section overflow-hidden"
    >
      <div className="pf-container relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-7">
            <Reveal>
              <span className="pf-mono text-[11px] uppercase tracking-wider text-[#D94A14]">
                {c.eyebrow}
              </span>
            </Reveal>
            <Reveal delay={0.06}>
              <h2 className="mt-3 pf-display text-[32px] sm:text-[44px] leading-tight tracking-tight text-[hsl(var(--foreground))]">
                {c.title_line1}
                <br />
                <span className="text-[#F35A1F]">{c.title_line2}</span>
              </h2>
            </Reveal>
            <Reveal delay={0.12}>
              <p className="mt-4 max-w-xl text-base sm:text-lg text-[hsl(var(--muted-foreground))] leading-relaxed">
                {c.description}
              </p>
            </Reveal>
            <Reveal delay={0.18}>
              <div className="mt-6 inline-flex items-center gap-3 rounded-2xl border border-[hsl(var(--border))] bg-white px-4 py-3 pf-shadow-sm">
                <span className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-[#F35A1F] text-white">
                  <Sparkles className="h-4 w-4" />
                </span>
                <p className="text-sm text-[hsl(var(--foreground))]">
                  <span className="font-semibold">Our mission:</span>{" "}
                  {c.mission}
                </p>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-5">
            <Reveal delay={0.12}>
              <div className="relative rounded-3xl border border-[hsl(var(--border))] bg-[#FFEEE6] p-6 sm:p-8 overflow-hidden">
                <div className="pointer-events-none absolute -right-4 -top-4 opacity-25" aria-hidden="true">
                  <FoxMotif size={180} testId="about-fox-motif" />
                </div>
                <ul className="relative grid grid-cols-1 gap-4">
                  {values.map((v, i) => {
                    const Icon = getIcon(v.icon);
                    const slug = (v.title || `value-${i}`).toLowerCase().replace(/\s+/g, "-");
                    return (
                      <li
                        key={`${slug}-${i}`}
                        data-testid={`about-value-${slug}`}
                        className="flex items-start gap-3 rounded-2xl border border-white bg-white p-4 pf-shadow-sm"
                      >
                        <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-[#FFEEE6] text-[#D94A14]">
                          <Icon className="h-4 w-4" />
                        </span>
                        <div>
                          <p className="pf-display text-[15px] text-[hsl(var(--foreground))]">
                            {v.title}
                          </p>
                          <p className="mt-1 text-[13px] leading-relaxed text-[hsl(var(--muted-foreground))]">
                            {v.desc}
                          </p>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
